exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".landing-wrapper[data-v-45fecb1a]{-webkit-box-sizing:border-box;box-sizing:border-box}.landing-wrapper .cmp__wrap[data-v-45fecb1a]{position:relative}.landing-wrapper .bg-image[data-v-45fecb1a]{background-repeat:no-repeat;background-size:cover;margin:0 auto;padding:0 1rem}@media screen and (max-width:47.9375em){.landing-wrapper .cmp__wrap[data-v-45fecb1a] >.landing-banner{margin-top:0}}", ""]);

// exports
